import React, { useCallback } from 'react';
import styles from './SingleSelectFilter.module.scss';
import searchFiltersStyles from '../SearchFilters.module.scss';
import { scrollToTop } from '../../helpers/Utils';

interface SingleSelectFilterProps {
    filterId: string;
    indexPropertyName: string;
    title: string;
    options: { label: string; count: number }[];
    selectedOption: string | null; // Use prop for selected option
    onOptionSelect: (filterId: string, labels: string[]) => void;
}

const SingleSelectFilter: React.FC<SingleSelectFilterProps> = ({ filterId, indexPropertyName, title, options, selectedOption, onOptionSelect }) => {
    const handleOptionClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>, optionLabel: string) => {
            e.preventDefault();
            if (selectedOption === optionLabel) {
                onOptionSelect(indexPropertyName, []); // Unselect if already selected
                return;
            }
            onOptionSelect(indexPropertyName, [optionLabel]); // Pass as string[]
            scrollToTop();
        },
        [filterId, indexPropertyName, onOptionSelect, selectedOption]
    );

    return (
        <React.Fragment>
            {/* Single Select Filter */}
            <div className={`${styles["single-select-filter"]} ${searchFiltersStyles["filter-item"]}`}>
                <h3 className={searchFiltersStyles["filter-title"]}>{title}</h3>
                <ul className="mt-3">
                    {options?.map((option, index) => {
                        const isSelected = selectedOption === option.label; // Check if the option is selected
                        return (
                            <li key={index}>
                                <a
                                    href="#"
                                    className={`${isSelected ? styles["selected"] : ""}`}
                                    onClick={(e) => handleOptionClick(e, option.label)}
                                >
                                    {option.label} <span>({option.count})</span>
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
            {/* /Single Select Filter */}
        </React.Fragment>
    );
};

export default SingleSelectFilter;